<ul>
  @if (!combinedOutput) {
    <li>
      <section>
        <div class="checkbox-wrapper">
          <form [formGroup]="config">
            <mat-checkbox
              formControlName="saveBackToDataSource"
              [matTooltip]="'Check to save this section back to the data source when the envelope is completed'"
              [matTooltipPosition]="'right'"
              [matTooltipShowDelay]="500"
            >
              Save back to data source
            </mat-checkbox>
          </form>
        </div>
      </section>
    </li>
  }
  <li>
    <app-upload-file
      [formGroup]="section"
      [workflowConfigId]="workflowConfigId"
      [tooltip]="'Fixed file'"
      [acceptableFileTypes]="['.pdf', '.doc', '.docx']"
      [notifyUserOnInvalidFile]="true"
      [showInfoIcon]="false">
    </app-upload-file>
  </li>
</ul>
